<p-dialog
    (onHide)="onHide()"
    (onShow)="onShow()"
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
>
    <ng-template #header> {{ "uploadDetailsDialog.title" | translate }}</ng-template>

    @if (dialogForm) {
    <form [formGroup]="dialogForm">
        <div class="p-16 m-border-bottom">
            <div class="m-form-group">
                <div class="flex flex-wrap">
                    @if (canDownloadPulsesFile) {
                    <a
                        class="m-btn m-btn-default"
                        href="{{upload.url}}"
                    >
                        <app-svg-icon icon="download"></app-svg-icon>
                        {{'uploadDetailsDialog.downloadPulsesFile' | translate}}
                    </a>
                    } @if (canDownloadAnalysisFile) {
                    <app-icon-button
                        class="ml-8"
                        (click)="downloadAnalysis()"
                        [showSpinner]="downloadingAnalysis"
                        icon="download"
                        label="uploadDetailsDialog.downloadAnalysisFile"
                        styleClass="m-btn m-btn-default"
                    ></app-icon-button>
                    }
                </div>
            </div>
        </div>
        @if (upload?.processMessage) {
        <div class="alert alert-error">{{upload.processMessage}}</div>
        }
    </form>
    }

    <ng-template #footer>
        <input
            class="m-btn m-btn-primary"
            (click)="close()"
            type="button"
            value="{{ 'form.cancel' | translate }}"
        />
    </ng-template>
</p-dialog>
